import {ILeadSendPendingAction, IPhoneVerificationPendingAction, PhoneVerificationPendingActionType} from "../types/phone_verification_types";

export const isLeadSendPendingAction = (pendingAction: IPhoneVerificationPendingAction): pendingAction is ILeadSendPendingAction =>
    pendingAction.type === PhoneVerificationPendingActionType.LEAD_SEND;

export const isPendingActionSuppressingPassivePrompt = (pendingAction: IPhoneVerificationPendingAction): boolean =>
    pendingAction.type === PhoneVerificationPendingActionType.LEAD_SEND ||
    pendingAction.type === PhoneVerificationPendingActionType.HM_ACTIVATION ||
    pendingAction.type === PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING;

export const getLeadPayloadPhone = (pendingAction: IPhoneVerificationPendingAction): string | undefined =>
    isLeadSendPendingAction(pendingAction) ? pendingAction.leadPayload.phone : undefined;
import {ILeadSendPendingAction, IPhoneVerificationPendingAction, PhoneVerificationPendingActionType} from "../types/phone_verification_types";

export const isLeadSendPendingAction = (pendingAction: IPhoneVerificationPendingAction): pendingAction is ILeadSendPendingAction =>
    pendingAction.type === PhoneVerificationPendingActionType.LEAD_SEND;

export const isPendingActionSuppressingPassivePrompt = (pendingAction: IPhoneVerificationPendingAction): boolean =>
    pendingAction.type === PhoneVerificationPendingActionType.LEAD_SEND ||
    pendingAction.type === PhoneVerificationPendingActionType.HM_ACTIVATION ||
    pendingAction.type === PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING;

export const getLeadPayloadPhone = (pendingAction: IPhoneVerificationPendingAction): string | undefined =>
    isLeadSendPendingAction(pendingAction) ? pendingAction.leadPayload.phone : undefined;
